import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import EmployeeLayout from "./layouts/EmployeeLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import Employees from "./pages/admin/Employees";
import EmployeeDetail from "./pages/admin/EmployeeDetail";
import AdminAttendance from "./pages/admin/Attendance";
import AdminLeave from "./pages/admin/Leave";
import Payroll from "./pages/admin/Payroll";
import Reports from "./pages/admin/Reports";
import Announcements from "./pages/admin/Announcements";
import Settings from "./pages/admin/Settings";
import Fnf from "./pages/admin/Fnf";
import CompanyDocs from "./pages/admin/CompanyDocs";
import AuditLog from "./pages/admin/AuditLog";
import EmpHome from "./pages/employee/Home";
import MyAttendance from "./pages/employee/MyAttendance";
import MyLeave from "./pages/employee/MyLeave";
import MyPayslips from "./pages/employee/MyPayslips";
import MyProfile from "./pages/employee/MyProfile";
import CompanyDocuments from "./pages/employee/CompanyDocuments";
import ChangePassword from "./pages/ChangePassword";

function Guard({ children, admin }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  const isAdmin = user.role === "super_admin" || user.role === "hr_admin";
  if (admin && !isAdmin) return <Navigate to="/employee" replace />;
  if (!admin && isAdmin) return <Navigate to="/admin" replace />;
  return children;
}

function AuthedOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<AuthedOnly><ChangePassword /></AuthedOnly>} />
          <Route path="/admin" element={<Guard admin><AdminLayout /></Guard>}>
            <Route index element={<AdminDashboard />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employees/:id" element={<EmployeeDetail />} />
            <Route path="attendance" element={<AdminAttendance />} />
            <Route path="leave" element={<AdminLeave />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="fnf" element={<Fnf />} />
            <Route path="documents" element={<CompanyDocs />} />
            <Route path="reports" element={<Reports />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="/employee" element={<Guard><EmployeeLayout /></Guard>}>
            <Route index element={<EmpHome />} />
            <Route path="attendance" element={<MyAttendance />} />
            <Route path="leave" element={<MyLeave />} />
            <Route path="payslips" element={<MyPayslips />} />
            <Route path="documents" element={<CompanyDocuments />} />
            <Route path="profile" element={<MyProfile />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
